/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FaceASadIcon20Solid = forwardRef('FaceASadIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-2.831-4.395c.307-.998 1.446-1.832 2.831-1.832s2.524.835 2.832 1.832a.875.875 0 0 0 1.672-.515c-.572-1.858-2.492-3.067-4.504-3.067-2.012 0-3.932 1.209-4.504 3.067a.875.875 0 0 0 1.673.515Z" })));
});
